import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import XMLDetailsFormatterHelper from './xmldetails-formatter-helper';
import TranslationService from '../../services/translation.service';

var GetHeaders = XMLDetailsFormatterHelper.GetHeaders;
var FindColumnOption = XMLDetailsFormatterHelper.FindColumnOption;
var composeError = XMLDetailsFormatterHelper.composeError;
var SetWhereConditionForInnerGrid = XMLDetailsFormatterHelper.SetWhereConditionForInnerGrid;

var INNER_ROWS_PAGE_SIZE = 10;

function SearchGrid2Formatter(params, observableOptions, dataSources) {
    var self = this;

    self.observableOptions = observableOptions;
    self.formatterCommon = FormatterCommon;
    self.gridFormatterCommon = new GridFormatterCommon();

    self.dataSources = dataSources;

    self.sourcetype = _.get(params, 'type', '');
    self.datapresorted = _.get(params, 'datapresorted', false);
    self.dataprepaged = _.get(params, 'dataprepaged', false);
    self.observableParams = _.get(_.first(dataSources), 'observableParams');

    self.observableFormattedData = ko.observable({});

    self.subscriptions = [];
}

function ComposeData(formatterCommon, gridFormatterCommon, sourcetype, sourcelist, options, initFlag, presorted, prepaged, dataProvider, dataSources, errMsg) {
    if (errMsg) {
        return composeError(errMsg);
    }

    var widths = GetWidths(options);
    var headers = GetHeaders(options.display, options.columnOptions);

    if (_.isEmpty(sourcelist) || _.isEmpty(_.get(options, 'display'))) {
        return gridFormatterCommon.composeEmpty(headers, options.display, widths);
    }
    let translationService = new TranslationService();

    var finalList = [];
    var maxCount = null;

    var innerheaders = null;
    var idCols = [];
    var idCol = "id";
    var innerQueryId = null;
    var innerSortColumn = null;
    var innerColumnOptions = null;
    var innerColumnDisplay = null;
    var innerWidths = null;
    var innerparentFkColumns = null;

    if (hasInnerGridData(options.columnOptions)) {
        _.forEach(options.columnOptions, function(columnOption) {
            if (columnOption.name === "innerGridData") {
                innerQueryId = columnOption.queryId;
                innerSortColumn = columnOption.sortColumn;
                innerparentFkColumns = columnOption.parentFkColumns;
                innerColumnOptions = columnOption.columnOptions;
                innerColumnDisplay = columnOption.display;
                innerheaders = GetHeaders(innerColumnDisplay, innerColumnOptions);
                innerWidths = GetWidths(columnOption);
            }

            if (columnOption.idCol) {
                idCols.push(columnOption.name);
            }
        });

        idCol = !_.isEmpty(idCols) ? _.first(idCols) : idCol;
    } else {
        idCols = _.chain(options.columnOptions)
            .filter(_.isNil)
            .map('name')
            .value();

        idCol = !_.isEmpty(idCols) ? _.first(idCols) : idCol;
    }

    maxCount = sourcelist.length;

    var sortedList = presorted ? sourcelist : gridFormatterCommon.sortList(sourcelist, _.keys(_.first(sourcelist)), options);
    var pagedList = prepaged ? sortedList : gridFormatterCommon.pageList(sortedList, options);

    _.forEach(pagedList, function(item) {
        var row = {};

        if (item[idCol]) {
            row.id = item[idCol];
        }

        _.forEach(options.display, function(displayCol) {
            row[displayCol] = GetFormattedValue(item[displayCol], displayCol, options.columnOptions);
        });

        _.forEach(idCols, function(ic) {
            row["_" + ic] = item[ic];
        });

        maxCount = item._recordCount || maxCount;

        if (item._pageID) {
            row._pageID = item._pageID;
        }
        if (item._pageCount) {
            row._pageCount = item._pageCount;
        }

        if (innerheaders) {
            var paramsJson = dataSources[0].observableParams().paramsJson;
            var requestPayload = JSON.parse(paramsJson);

            row.innerTable = {
                headers: ko.observableArray(innerheaders),
                rows: ko.observableArray(),
                currentPage: ko.observable(1),
                totalPages: ko.observable(1),
                sortAsc: ko.observable(true),
                sortIndex: ko.observable(),
                displayCols: ko.observable(innerColumnDisplay),
                sortColumn: ko.observable(innerSortColumn)
            };

            row._loadInnerRows = function (pageNum, sortColumn) {
                SetWhereConditionForInnerGrid(requestPayload, innerparentFkColumns, this);

                requestPayload.sortColumn = sortColumn || ko.unwrap(_.get(row, 'innerTable.sortColumn'));
                requestPayload.pageSize = INNER_ROWS_PAGE_SIZE;
                requestPayload.pageNum = pageNum || 1;

                paramsJson = ko.toJSON(requestPayload);

                var queryId = innerQueryId;

                return dataProvider.getQueryResultJson(queryId, paramsJson).then(function (innerData) {
                    if (!_.isEmpty(innerData) && !_.isEmpty(innerColumnDisplay)) {
                        var innerResult = [];
                        var innermaxcount = 0;

                        _.forEach(innerData, function(innerItem) {
                            var tempInnerObj = {};

                            _.forEach(innerColumnDisplay, function(innerDisplay) {
                                tempInnerObj[innerDisplay] = GetFormattedValue(innerItem[innerDisplay], innerDisplay, innerColumnOptions);
                            });

                            if (!innermaxcount && innerItem._recordCount) {
                                innermaxcount = innerItem._recordCount;
                            }
                            innerResult.push(tempInnerObj);
                        });

                        row.innerTable.totalPages(requestPayload.pageSize);

                        if (innermaxcount && requestPayload.pageSize) {
                            row.innerTable.totalPages(Math.ceil(innermaxcount / requestPayload.pageSize));
                            row._showInnerPager(row.innerTable.totalPages() > 1);
                        }
                        row.innerTable.rows(innerResult);
                        row.innerTable.currentPage(requestPayload.pageNum);
                    } else {
                        row.innerTable.totalPages(0);
                        row.innerTable.rows([]);
                    }

                    return Promise.resolve();
                });
            };

            row._showInnerPager = ko.observable(false);

            row._actionCallback = function (index) {
                var colOpt = FindColumnOption(options.display[index - 1], options.columnOptions);

                if (_.isFunction(_.get(colOpt, 'clickActionCallback'))) {
                    colOpt.clickActionCallback(this, JSON.parse(paramsJson));
                }
            };

        }

        finalList.push(row);
    });


    return {
        maxCount: maxCount,
        headers: headers,
        rowProperties: options.display,
        rows: finalList,
        widths: widths,
        innerRowDisplayIndex: 0,
        innerWidths: innerWidths
    };
}

function GetWidths(options) {
    var widthRatios = [];
    var sum = 0;

    _.forEach(options.display, function(name) {
        var colOption = FindColumnOption(name, options.columnOptions);

        if (_.get(colOption, 'minWindowWidth') && ($(window).width() < colOption.minWindowWidth)) {
            widthRatios.push(1);
        } else {
            if (_.get(colOption, 'widthRatio')) {
                widthRatios.push(colOption.widthRatio);
                sum += colOption.widthRatio;
            } else {
                widthRatios.push(1);
                sum += 1;
            }
        }
    });

    sum = sum === 0 ? 1 : sum;

    return _.map(widthRatios, function(wRatio) {
        return (100 * wRatio / sum) + '%';
    });
}

function GetFormattedValue(rawValue, name, columnOptions) {
    var colOption = FindColumnOption(name, columnOptions);
    return _.has(colOption, 'format') ? colOption.format(rawValue) : rawValue;
}

function hasInnerGridData(columnOptions) {
    return !_.isUndefined(_.find(columnOptions, {name: 'innerGridData'}));
}

SearchGrid2Formatter.prototype = {
    initialize: function(dataRepository, dataProvider) {
        var self = this;

        self.dataRepository = dataRepository;
        self.dataProvider = dataProvider;

        self.subscriptions.push(self.dataRepository.QueryResultDictionary.subscribe(function () {
            self.DataUpdated();
        }));

        self.observableFormattedData({
            loadFromCacheCallback: self.LoadFromCache,
            context: self
        });
    },

    RefreshData: function () {
        var self = this;

        if (_.isEmpty(self.observableParams())) {
            return;
        }

        self.sourceList = self.dataRepository.getDictionaryValue(self.dataRepository.QueryResultDictionary, self.observableParams());
        var errMsg = self.dataRepository.getErrorValue(self.observableParams());

        if (self.sourceList !== null) {
            self.observableFormattedData(ComposeData(self.formatterCommon,
                self.gridFormatterCommon,
                self.sourcetype,
                self.sourceList,
                self.observableOptions(),
                null,
                self.datapresorted,
                self.dataprepaged,
                self.dataProvider,
                self.dataSources,
                errMsg));
        }
    },
    LoadFromCache: function (params, context) {
        var self = context;
        var sourceList = self.dataRepository.getDictionaryValue(self.dataRepository.QueryResultDictionary, params);

        if (sourceList === null) {
            return false;
        }

        var errMsg = self.dataRepository.getErrorValue(params);

        self.observableFormattedData(ComposeData(self.formatterCommon,
            self.gridFormatterCommon,
            self.sourcetype,
            sourceList,
            self.observableOptions(),
            null,
            self.datapresorted,
            self.dataprepaged,
            self.dataProvider,
            self.dataSources,
            errMsg));

        return true;
    },

    DataUpdated: function() {
        this.RefreshData();
    },

    OptionsUpdated: function() {
        this.RefreshData();
    },

    getObservableData: function() {
         return this.observableFormattedData;
    },

    dispose: function() {
        this.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    }
};

export default SearchGrid2Formatter;
